import { PronunciationPair } from "@/types/agent/agent";
import { PronunciationChange } from "@/types/agent/pronunciation-vault";

const normalize = (value: string) => value.trim().toLowerCase();

export function removedPronunciations(pairs: PronunciationPair[]): PronunciationChange[] {
  return pairs
    .filter((p) => p.word.trim() && p.pronunciation.trim())
    .map((p) => ({ word: p.word.trim(), from: p.pronunciation.trim(), to: null }));
}

export function findChangedPronunciations(
  before: PronunciationPair[],
  after: PronunciationPair[],
): PronunciationChange[] {
  const current = new Map(after.map((p) => [normalize(p.word), p.pronunciation.trim()]));
  return removedPronunciations(before).flatMap((change) => {
    const to = current.get(normalize(change.word));
    if (to === undefined) return [change];
    return to && normalize(to) !== normalize(change.from) ? [{ ...change, to }] : [];
  });
}

export function mergePronunciations(
  existing: PronunciationPair[],
  incoming: PronunciationPair[],
): PronunciationPair[] {
  const map = new Map(existing.map((p) => [p.word.toLowerCase(), p]));
  for (const p of incoming) map.set(p.word.toLowerCase(), p);
  return Array.from(map.values());
}
